import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { extractError } from "../lib/formatError";
import { AuthShell, TextField } from "./Signup";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await api.post("/auth/request-password-reset", { email });
      setSent(true);
    } catch (e2) {
      setError(extractError(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Forgot password" subtitle="We'll send you a reset link" testid="forgot-password-page">
      {sent ? (
        <div data-testid="forgot-sent">
          <div className="text-[color:var(--gold)] font-display italic text-2xl mb-3">Check your inbox.</div>
          <p className="text-sm text-[color:var(--muted)] mb-6">
            If an account exists for that email, we've sent a password-reset link.
            In dev mode the link is also logged to <code>backend/last_emails.jsonl</code>.
          </p>
          <Link to="/login" className="text-xs uppercase tracking-widest text-[color:var(--muted)] hover:text-[color:var(--ink)]">
            ← Back to log in
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <TextField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} testid="forgot-email" required />
          {error && (
            <div className="text-xs text-[color:var(--red)] border border-[color:var(--red)] px-3 py-2" data-testid="forgot-error">
              {error}
            </div>
          )}
          <button type="submit" disabled={busy} className="spin-btn w-full" data-testid="forgot-submit-btn">
            {busy ? "Sending…" : "Send reset link"}
          </button>
          <div className="text-center text-xs text-[color:var(--muted)]">
            <Link to="/login" className="text-[color:var(--gold)]">Back to log in</Link>
          </div>
        </form>
      )}
    </AuthShell>
  );
}
